module.exports = __webpack_public_path__ + "img/unlockProject.d4f93105.svg";